import { GapChaseFilterBase, filterType, dataType } from '../../GapChaseFilterBase';
import Axios from 'axios';

export default class ProviderInclusionListFilter extends GapChaseFilterBase {
    constructor(chaseFilterData) {
        super();
        this.id = 37;
        this.name = "Provider Inclusion List";
        this.filterName = "ProviderInclusionLists";
        //this.isHidden = true;
        this.filterType = filterType.multiSelect;

        this.values = [];
        if (chaseFilterData.ProviderIncExNames !== null && chaseFilterData.ProviderIncExNames !== "undefined")
            this.values = chaseFilterData.ProviderIncExNames;

        this.dataType = dataType.number;
        this.filterCategory = "Provider Level";
        this.filterGroupId = 4;
        this.placeholder = "Provider Inclusion List";

    }

}
